"use client";

import { defineStepper } from "@stepperize/react";
import { BoxSelect, ArrowRightLeft, FileText, CheckCircle2 } from "lucide-react";

export const { Stepper, ...stepperDefinition } = defineStepper(
  {
    id: "selection",
    title: "Select Input & Batch",
    description: "Choose input and batch",
    icon: BoxSelect,
  },
  {
    id: "movementType",
    title: "Movement Type",
    description: "Receipt / Issue / Return / Adjustment",
    icon: ArrowRightLeft,
  },
  {
    id: "details",
    title: "Movement Details",
    description: "Fill in the details",
    icon: FileText,
  },
  {
    id: "review",
    title: "Review & Submit",
    description: "Confirm your entry",
    icon: CheckCircle2,
  }
);